import React, {Component} from 'react';
import {Button, Card, Col, Row, Tabs, Input} from "antd";
import SearchBox from "./SearchBox";
import {connect} from "react-redux";
import {getCompaniesQuery} from "../../actions/companies";
import {CompaniesView} from "./CompaniesView";
import CompanyNew from "../Companies/CompanyNew";


class CompanySearch extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      newCompany: false
    };
  }

  componentDidMount() {
    const { onMount } = this.props;
    if (onMount) onMount();
  }

  handleInvite = (company) => {
    const { onJoin } = this.props;
    if (onJoin) onJoin(company);
  };

  handleCreate = (company) => {
    const { onCreate } = this.props;
    if (onCreate) onCreate(company);
  };

  showNewCompany = () => {
    this.setState({ newCompany: true });
  };

  hideNewCompany = () => {
    this.setState({ newCompany: false });
  };

  render() {
    const { newCompany } = this.state;
    if (newCompany) {
      return (
        <div className='edit-view wide'>
          <CompanyNew onSubmit={this.handleCreate} onCancel={this.hideNewCompany}/>
        </div>
      );
    } else {
      const { searchState, searchResults, onSearch, onCreateCompany } = this.props;
      const { extras } = this.props;  // shape of this is (handleInvite) => (contact) => React node
      return (
        <div>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <h3>Join Your Company</h3>
            <div>... or <Button onClick={this.showNewCompany}>Create Your Company</Button></div>
          </div>
          {/*<Card*/}
          {/*  title='Company Selection'*/}
          {/*  extra={<Button icon='plus' onClick={this.showNewCompany}>Create Company</Button>}*/}
          {/*>*/}
            <SearchBox
              placeholder="Search by company name, city, state, zip, etc..."
              onChange={onSearch}
              className='contact-search control-search'
            />
            {
              (searchResults.length === 0 && searchState === 'complete')
                ? <div><div className='contacts-header'/></div>
                : <CompaniesView
                  companies={searchResults}
                  extras={extras(this.handleInvite)}
                />
            }
          {/*</Card>*/}
        </div>
      );
    }
  }
}

export default connect(
  (state, props) => ({
    searchResults: state.ui.companySearchResults,
    searchState: state.ui.companySearchState,
    extras: (handleInvite) => (contact) => <Button onClick={() => handleInvite(contact)}>Request to Join</Button>
  }),
  (dispatch, props) => ({
    onSearch: (query) => dispatch(getCompaniesQuery(query)),
  })
)(CompanySearch);



// WEBPACK FOOTER //
// ./src/components/Boilerplate/CompanySearch.js